import { render, staticRenderFns } from "./Recientes.vue?vue&type=template&id=5f13fa20&"
import script from "./Recientes.vue?vue&type=script&lang=js&"
export * from "./Recientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports